export function isPriceStatusLabelsEnabled() {
    try {
        const local = localStorage.getItem('ff_price_status_labels');
        if (local === '0' || local === 'false') return false;
        if (local === '1' || local === 'true') return true;
    } catch (_) {
        // no-op
    }
    if (process.env.REACT_APP_FF_PRICE_STATUS_LABELS === '0') return false;
    // Default ON for live rollout; keep explicit kill switch via env/localStorage.
    return true;
}

export function resolvePriceStatusLabel(item) {
    if (!item || typeof item !== 'object') return null;
    const raw = String(item.priceStatusLabel || item.priceStatus || '').toLowerCase();
    if (!raw) return null;
    if (raw.includes('adv') || raw.includes('avantaj')) return 'Avantajli';
    if (raw.includes('high') || raw.includes('yuksek')) return 'Yuksek';
    if (raw.includes('wave') || raw.includes('dalga')) return 'Dalgali';
    if (raw.includes('normal')) return 'Normal';
    if (raw.includes('updat') || raw.includes('guncel')) return 'Guncelleniyor';
    return null;
}

export function getPriceStatusBadgeClass(label) {
    const key = String(label || '').toLowerCase();
    if (key === 'avantajli') return 'bg-emerald-100 text-emerald-700';
    if (key === 'yuksek') return 'bg-orange-100 text-orange-700';
    if (key === 'dalgali') return 'bg-amber-100 text-amber-700';
    if (key === 'guncelleniyor') return 'bg-slate-100 text-slate-700';
    return 'bg-blue-100 text-blue-700';
}

export function getPriceStatusMessage(label) {
    const key = String(label || '').toLowerCase();
    if (key === 'avantajli') return 'Bu urun su an gorece avantajli seviyede.';
    if (key === 'yuksek') return 'Bu urun piyasada yuksek seyrediyor, erteleyebiliriz.';
    if (key === 'dalgali') return 'Bu urunde kisa donem fiyat dalgalanmasi goruluyor.';
    if (key === 'normal') return 'Bu urun su an normal fiyat araliginda.';
    if (key === 'guncelleniyor') return 'Bu urunun fiyat verisi guncelleniyor.';
    return null;
}
